// extracted by mini-css-extract-plugin
export var cancelButton = "ReportModal-module--cancelButton--IyOAm";
export var content = "ReportModal-module--content--tmnYs";
export var footer = "ReportModal-module--footer--j3ZAC";
export var header = "ReportModal-module--header--7nV5e";
export var noOrders = "ReportModal-module--noOrders--1bEZA";